import NoMatch from 'containers/NoMatch';
import React, { useMemo } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

const Routes = ({
  routes,
}) => {
  const flattenedRoutes = useMemo(() => {
    const flattenRoutes = (routeList) => routeList.reduce((arr, route) => {
      if (route.children) {
        arr.push(...flattenRoutes(route.children));
      }
      if (route.path && route.component) {
        arr.push(route);
      }
      return arr;
    }, []);

    return flattenRoutes(routes);
  }, [routes]);

  return (
    <Switch>
      {flattenedRoutes.toSorted((a, b) => b.path.length - a.path.length).map(route => (
        <Route
          key={route.path}
          exact={route.exact}
          path={route.path}
        >
          <route.component {...route.props} />
        </Route>
      ))}
      <Route path="*">
        {flattenedRoutes.length > 0 ? <Redirect to={flattenedRoutes[0].path} /> : <NoMatch />}
      </Route>
    </Switch>
  );
};

export default Routes;
